<script setup>
import { watch } from 'vue';
import { generateHTML } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';

const link = 'https://proctoring-api.univora.uz/services/platon-core/uploads/files/';

const { question, disabled } = defineProps({ question: Object, disabled: Boolean });
const modelValue = defineModel();

watch(
    () => question.answers,
    (newAnswers) => {
        if (newAnswers) {
            if (question.isMultiple) {
                modelValue.value = newAnswers.filter((opt) => opt.checked).map((opt) => opt.id);
            } else {
                modelValue.value = newAnswers?.find((opt) => opt.checked)?.id || [];
            }
        }
    },
    { immediate: true, deep: true }
);
</script>
<template>
    <div class="answers-content">
        <label
            class="answers-content-item"
            v-for="answer in question.answers"
            :key="answer.id"
            :class="{
                active: modelValue.includes(answer.id),
                correct: answer.isCorrect,
                incorrect: answer.isCorrect == false,
                disabled,
            }"
        >
            <div v-if="answer.isCorrect == undefined">
                <Checkbox :value="answer.id" v-model="modelValue" v-if="question.isMultiple" :disabled="disabled" />
                <RadioButton v-else :value="answer.id" v-model="modelValue" :disabled="disabled" />
            </div>

            <i v-else :class="answer.isCorrect ? 'pi pi-check-circle pass-icon' : 'pi pi-times-circle fail-icon'"></i>
            <img v-if="answer.image" :src="link + answer.image" class="answer-image" />
            <p v-if="answer.content" v-html="generateHTML(answer.content, [StarterKit])"></p>
        </label>
    </div>
</template>

<style scoped>
.answers-content {
    @apply flex gap-4 w-full flex-wrap;
}
.answers-content-item {
    @apply w-[calc(50%-10px)] p-4 border border-gray-200 rounded-xl flex items-center gap-4 cursor-pointer bg-white hover:bg-gray-50 transition duration-300;
}
.answers-content-item.active {
    @apply border-black;
}
.answers-content-item.disabled {
    @apply bg-gray-100 pointer-events-none;
}
.answers-content-item.correct {
    @apply bg-green-100;
}
.answers-content-item.incorrect {
    @apply bg-red-100;
}
.answers-content-item.active.correct {
    @apply border-green-500;
}
.answers-content-item.active.incorrect {
    @apply border-red-500;
}
.answer-image {
    @apply w-32 h-32 object-cover rounded-lg;
}
.pass-icon {
    @apply text-green-500 text-[21px];
}
.fail-icon {
    @apply text-red-500 text-[21px];
}

/* Mobile adaptations */
@media (max-width: 768px) {
    .answers-content {
        @apply gap-3;
    }

    .answers-content-item {
        @apply w-full p-3 gap-3 rounded-lg;
    }

    .answer-image {
        @apply w-24 h-24;
    }
}

@media (max-width: 480px) {
    .answers-content {
        @apply gap-2;
    }

    .answers-content-item {
        @apply p-2.5 gap-2 text-sm;
    }

    .answer-image {
        @apply w-20 h-20;
    }

    .pass-icon,
    .fail-icon {
        @apply text-[18px];
    }
}
</style>
